import React from 'react';
import { createTheme } from '@mui/material/styles';
import { COLORS } from '../Constants/styles';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    body3: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    body3?: React.CSSProperties;
  }
}
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    body3: true;
  }
}

const baseTheme = createTheme()

const theme = createTheme({
    typography: {
        fontFamily: "'Inter', sans-serif",

        // ✅ Custom variants (usable with <Typography variant="heroHeading" />)
        heroHeading: {
            fontSize: '3rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            fontFamily: "'Big Shoulders Text', sans-serif",
            color: '#fff',
        },
        sectionSubtitle: {
            fontSize: '1rem',
            fontWeight: 700,
            fontFamily: 'Inter',
            color: '#fff',
        },
        sectionDescription: {
            fontSize: '1rem',
            fontFamily: 'Inter',
            color: '#fff',
        },
        subtitle1: {
            fontFamily: "'Big Shoulders Text', sans-serif",
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '2px',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontStyle: 'normal',
            [baseTheme.breakpoints.up('xs')]: {
                fontSize: '0.75rem',
            },
            [baseTheme.breakpoints.up('sm')]: {
                fontSize: '0.75rem',
            },
            [baseTheme.breakpoints.up('md')]: {
                fontSize: '0.75rem',
            },
        },
        subtitle2: {

        },

        // ✅ Map heading levels to valid MUI variants
        h1: {
            fontFamily: "'Big Shoulders Text', sans-serif",
            // fontSize: '64px',
            fontWeight: 600,
            textTransform: 'uppercase',
            lineHeight: '1.1em',
            [baseTheme.breakpoints.up('xs')]: {
                fontSize: '34px',
            },
            [baseTheme.breakpoints.up('sm')]: {
                fontSize: '44px',
            },
            [baseTheme.breakpoints.up('md')]: {
                fontSize: '64px',
            },
        },
        h2: {

            fontFamily: "'Big Shoulders Text', sans-serif",
            fontSize: '2rem', // fallback
            fontWeight: 600,
            textTransform: 'uppercase',
            textDecoration: 'none',
            lineHeight: '1.2em',
            letterSpacing: '0px',
            color: COLORS.white,

            // ✅ Responsive overrides
            [baseTheme.breakpoints.up('xs')]: {
                fontSize: '1.75rem',
            },
            [baseTheme.breakpoints.up('sm')]: {
                fontSize: '2.0rem',
            },
            [baseTheme.breakpoints.up('md')]: {
                fontSize: '3.0rem',
            },
        },
        h3: {
            fontWeight: 600,
            fontFamily: "'Big Shoulders Text', sans-serif",
            textTransform: 'uppercase',
            letterSpacing: '0px',
            lineHeight: '1.3em',
            textDecoration: 'none',
            [baseTheme.breakpoints.up('xs')]: {
                fontSize: '1.75rem',
            },
            [baseTheme.breakpoints.up('sm')]: {
                fontSize: '2.0rem',
            },
            [baseTheme.breakpoints.up('md')]: {
                fontSize: '3.0rem',
            },
        },
        h4: {
            fontWeight: 600,
            fontFamily: "'Big Shoulders Text', sans-serif",
            textTransform: 'uppercase',
            lineHeight: '1.4em',
            letterSpacing: '0px',
            fontSize: "20px",
            fontStyle: 'normal',
        },
        h5: {
            fontFamily: "'Big Shoulders Text', sans-serif",
            textTransform: 'uppercase',
            fontSize: "14px",
            fontWeight: 600,
            textDecoration: 'none',
            lineHeight: '1.4em',
            letterSpacing: '1px',
        },
        h6: {
            fontFamily: "'Big Shoulders Text', sans-serif",
            textDecoration: 'none',
            textTransform: 'uppercase',
            fontWeight: "bold",
        },
        body1: {
            color: COLORS.accentBlackTransparent,
            fontFamily: "Inter",
            fontSize: "16px",
            letterSpacing: 0,
            lineHeight: "1.5em",
            wordSpacing: "0px",
            textTransform: "none",
            [baseTheme.breakpoints.up('xs')]: {
                fontSize: '14px',
            },
            [baseTheme.breakpoints.up('sm')]: {
                fontSize: '16px',
            },
            [baseTheme.breakpoints.up('md')]: {
                fontSize: '18px',
            },
        },

        body2: {
            color: COLORS.accentBlackTransparent,
            fontFamily: "Inter",
            fontSize: "15px",
            letterSpacing: 0,
            lineHeight: "1.5em",
            wordSpacing: "0px",
            textTransform: "none",
            textAlign: "justify",
            [baseTheme.breakpoints.up('xs')]: {
                fontSize: '14px',
            },
            [baseTheme.breakpoints.up('sm')]: {
                fontSize: '15px',
            },
            [baseTheme.breakpoints.up('md')]: {
                fontSize: '16px',
            },
        },
        body3: {
            color: COLORS.accentBlackTransparent,
            fontFamily: "Inter",
            letterSpacing: 0,
            lineHeight: "1.4em",
            wordSpacing: "0px",
            textTransform: "none",
            [baseTheme.breakpoints.up('xs')]: {
                fontSize: '12px',
            },
            [baseTheme.breakpoints.up('sm')]: {
                fontSize: '12px',
            },
            [baseTheme.breakpoints.up('md')]: {
                fontSize: '13px',
            },
        },
    },

    palette: {
        background: {
            default: '#f4f4f4',
        },
        primary: {
            main: '#1C4040',
        },
        secondary: {
            main: COLORS.accentLime,
        },
    },

});

export default theme;
